import { useCallback, useEffect, useMemo, useRef } from "react";
import { useSelector } from "react-redux";

import { dispatch } from "../../../../state/store";
import { setLocaleKeys } from "../../../../state/ducks";

import { appsService } from "../../../../services";

import { FlexContainers, WrapperContainer } from "../../../../components";
import { LocalisationTabTable, MissingKeysModal } from "../../../../containers";

const LocalisationTab = () => {
  const selectedApp = useSelector((store) => store.apps.selectedApp);

  const localeRef = useRef(null);

  const defaultLocalization = useMemo(() => {
    return selectedApp?.localizations?.find((localization) => localization.isDefault);
  }, [selectedApp]);

  const fetchJson = useCallback(async () => {
    try {
      const response = await appsService.getLocalization(defaultLocalization.path);
      dispatch(setLocaleKeys(response.data));
    } catch (error) {
      console.error("Error fetching JSON:", error);
      throw error;
    }
  }, [defaultLocalization]);

  useEffect(() => {
    if (
      localeRef.current !== defaultLocalization?.name &&
      defaultLocalization?.name &&
      defaultLocalization?.path
    ) {
      fetchJson();
      localeRef.current = defaultLocalization.name;
    }
  }, [defaultLocalization]);

  return (
    <WrapperContainer Container={FlexContainers.FlexColumn} width="100%" pr={24}>
      <LocalisationTabTable localizations={selectedApp?.localizations || []} />

      <MissingKeysModal />
    </WrapperContainer>
  );
};

export default LocalisationTab;
